import { Fragment } from "react";
import {
    useTable,
    useGlobalFilter,
    useSortBy,
    useFilters,
    useExpanded,
    usePagination,
    useRowSelect
} from "react-table";
import { Table, Row } from "reactstrap";
import { DefaultColumnFilter } from "../../Components/Common/filters";
import Paginator from "Components/Common/Paginator";
import DtsTablePlaceholder from "Components/Common/FormBuilder/DtsTablePlaceholder";
import { withTranslation } from "react-i18next";
import { DropdownActions } from "Components/Common/Actions/DropdownActions";

interface TableContainerProps {
    columns?: any;
    data?: any;
    tableClass?: any;
    theadClass?: any;
    isPageSizeChange?: any;
    trClass?: any;
    thClass?: any;
    pagination: any; 
    pageSize: any;
    pagesList: any;
    setisDeleteOpen: (e: any) => void;
    setRecord: (e: any) => void;
    pageChanged: (e: any) => void;
    onChangePageSize: (e: any) => void;
    isIconUp: boolean;    
    handleSort: (e: any) => void;
    sortBy:string;
    sortOrder:string;
    props: any;
    loading: any;
    extraActions: any
}

const TableContainer = ({
    columns,
    data,
    isPageSizeChange,
    tableClass,
    theadClass,
    trClass,
    thClass,
    setisDeleteOpen,
    setRecord,
    pageChanged,
    pagesList,
    pagination,
    onChangePageSize,
    pageSize,
    handleSort,
    sortOrder,
    sortBy,
    props,
    loading,
    extraActions
}: TableContainerProps) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        setPageSize,
    } = useTable(
        {
            columns,
            data,
            defaultColumn: { Filter: DefaultColumnFilter },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination,
        useRowSelect
    );    

    const onChangeInSelect = (event: any) => {
        setPageSize(Number(event.target.value));
        onChangePageSize(event.target.value);
    };

    return (
        <div>
        {loading ?
            <DtsTablePlaceholder 
            columns={columns} 
            theadClass={theadClass}     
            tableClass="align-middle table-nowrap"
            thClass="border-bottom-1 table-soft-primary"
        />
            : 
        <div> {!loading && page && page.length ? 
            <Table hover {...getTableProps()} className={tableClass + ' m-0'}>
                <thead className={theadClass}>
                    {headerGroups.map((headerGroup: any) => (
                        <tr className={trClass} key={headerGroup.id}  {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column: any) => (
                                <th key={column.id} className={thClass + " fw-bold"}
                                    {...column.isSortable ? { ...column.getSortByToggleProps() } : ""}
                                >
                                    <div onClick={() => handleSort(column.id)}>
                                        {column.render("Header")}
                                        {sortBy === 'title' && (
                                            <span>
                                                {sortOrder === 'asc' ? ' ▲' : ' ▼'}
                                            </span>
                                        )}
                                    </div>                                   
                                </th>
                            ))}
                            <th className={thClass + " fw-bold"} >
                                {props.t("student.listing.columns.actions")}
                            </th>
                        </tr>
                    ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                    {page.map((row: any) => {
                        prepareRow(row);
                        const url = new URL(row.original?.url);
                        const lastTwoParams = url.pathname.split('/').slice(-2);
                        let link = `/forms/view/${lastTwoParams[0]}`
                        return (
                            <Fragment key={row.getRowProps().key}>
                                <tr style={{verticalAlign: 'middle'}}>
                                    {row.cells.map((cell: any) => {
                                        return (
                                            <td key={cell.id} style={{verticalAlign: 'middle'}} className='align-items-center justify-content-between' {...cell.getCellProps()}>
                                                {cell.render("Cell")}
                                            </td>
                                        );
                                    })} 
                                     <td>
                                        <DropdownActions
                                            row={row}
                                            url={link}
                                            permissions={row.original?.permissions}
                                            extraActions={extraActions}
                                            handleLeadClick={setRecord}
                                            setIsDeleteOpen={setisDeleteOpen}  
                                            translater={props.t}
                                            module={"forms"}
                                        />
                                    </td>
                                </tr>
                            </Fragment>
                        );
                    })}
                </tbody>
            </Table>: <div className="hstack p-5 fw-semibold fs-16 justify-content-center w-100"><span className="hstack p-5  justify-content-center  fw-semibold fs-16 text-center w-100">{props.t("common.message.no_data_found")}</span></div> }
            <Row className="align-items-center mt-2 g-3 text-center text-sm-start">
                <div className="col-sm">
                    <div className="text-muted">
                        {props.t("common.pagination.showing")}
                        <span className="fw-semibold ms-1">
                        {data.length > 0 ? `${pagination.offset + 1}-${Math.min(pagination.offset + pagination.size, pagination.elements)} of ${pagination.elements} results` : `0-0 of 0 results`}
                        </span>
                    </div>
                </div>   
                <div className="col-sm-auto">
                    <Paginator total={pagination && pagination.elements ? pagination.elements : 0}
                        currentPage={pagination?.page}
                        pageChanged={(e:any) => pageChanged(e)}
                        pageSize={pageSize} 
                        isPageSizeChange={isPageSizeChange}
                        onChangeInSelect={(e:any) => onChangeInSelect(e)}
                        pagesList={pagesList}
                        pagination={pagination}
                        props={props}
                     />
                </div>
            </Row>
        </div>}
        </div>
    );
};

export default withTranslation()(TableContainer);